var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1901_467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1901_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3077 21.5C5.80257 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.30773C4.5 3.8026 4.675 3.37503 5.025 3.02503C5.375 2.67503 5.80257 2.50003 6.3077 2.50003H13.5019C13.7429 2.50003 13.9747 2.54683 14.1971 2.64043C14.4195 2.73401 14.6128 2.86286 14.7769 3.02696L18.973 7.22306C19.1371 7.38717 19.266 7.58045 19.3595 7.80288C19.4531 8.02531 19.5 8.25704 19.5 8.49806V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6922 21.5H6.3077ZM13.5 7.59613V4.00001H6.3077C6.23077 4.00001 6.16024 4.03206 6.09612 4.09616C6.03202 4.16027 5.99997 4.2308 5.99997 4.30773V19.6923C5.99997 19.7692 6.03202 19.8397 6.09612 19.9039C6.16024 19.968 6.23077 20 6.3077 20H17.6922C17.7692 20 17.8397 19.968 17.9038 19.9039C17.9679 19.8397 18 19.7692 18 19.6923V8.49998H14.4039C14.1462 8.49998 13.9311 8.41376 13.7587 8.24131C13.5862 8.06887 13.5 7.85381 13.5 7.59613Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.dd62499967df3961dd53dc1d641184ed.svg";
export { ForwardRef as ReactComponent };